import { useHabits, useRepeatingTasks } from 'features/tasks';
import uniqBy from 'lodash/uniqBy';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Section, Sizes } from 'shared/components/ui/section';
import { TasksList } from 'shared/components/ui/tasks-list';
import { Task } from 'shared/types/task';

import * as Styled from './archived-items-list.style';

export const ArchivedItemsList: React.FC = () => {
  const { t } = useTranslation();

  const habits = useHabits({
    archivedOnly: true,
  });
  const repeatingTasks = useRepeatingTasks({
    archivedOnly: true,
  });

  const archivedItems = useMemo(() => {
    const allItems = [...habits, ...repeatingTasks];

    // Deduplicate just in case, though likely not needed here as we don't merge overlapping sources
    const uniqueItems = uniqBy(allItems, 'id');

    return uniqueItems.sort(
      (a, b) => (a.archivedAt?.getTime() ?? 0) - (b.archivedAt?.getTime() ?? 0),
    ) as Task[];
  }, [habits, repeatingTasks]);

  if (!archivedItems.length) {
    return null;
  }

  return (
    <Styled.Container>
      <Section
        title={t('pages.goal-detail.tasks.archived.title', 'Archived')}
        titleCount={archivedItems.length}
        size={Sizes.Small}
        canCollapse
      >
        <TasksList tasks={archivedItems} />
      </Section>
    </Styled.Container>
  );
};
